import { render, staticRenderFns } from "./report-fengmian.vue?vue&type=template&id=3e27d00c&scoped=true&"
import script from "./report-fengmian.vue?vue&type=script&lang=ts&"
export * from "./report-fengmian.vue?vue&type=script&lang=ts&"
import style0 from "./report-fengmian.vue?vue&type=style&index=0&id=3e27d00c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e27d00c",
  null
  
)

export default component.exports